import { ToggleButton } from '../../toggleButton/toggleButton';

/**
 * Template for bedrooms number filter
 * @param {Object} facette - filter[facetteName]
 * @param {Object} wordings - SEARCH_SCRIPTS.WORDING_SEARCH
 * @return {string} - HTML content
 */
export const bedroomsNumberTpl = (facette, wordings) => {
  const facetteName = facette.code.toLowerCase();
  const codeWording = 'facette_' + facetteName + '_label_mobile';

  let htmlFacette = `
    <div class="searchFilters-filterTitle" id="filter_${facetteName}">${wordings[codeWording]}</div>
    <div class="searchFilters-filterBoxContainer searchFilters-filterBoxContainer--bedrooms">`;

  // Build form element based on ToggleButton
  $.each(facette.values, (index, item) => {
    const toggleButton = new ToggleButton({
      id: `facette_${facetteName}_${item.key}`,
      name: 'facet[' + facette.code + '][]',
      checked: item.selected,
      disabled: !item.enabled && !item.selected,
      label: item.value,
      value: item.key,
      attributes: {
        'data-facette': facetteName
      },
      inputClassNames: ['js-filterInput']
    });

    htmlFacette += toggleButton.render(true);
  });

  htmlFacette += '</div>';

  return htmlFacette;
};
